import { MonitoringBlackboxLookupDto } from "src/app/web-api/web-api";

export class MonitoringBlackboxLookupViewModel {
  private _model: MonitoringBlackboxLookupDto;
  private _id: string;
  private _systemType: string;

  public constructor(model: MonitoringBlackboxLookupDto) {
    this._model = model;

    const idx = model.id.indexOf(":", 0);
    this._systemType = model.id.substring(0, idx);
    this._id = model.id.substring(idx + 1, model.id.length);
  }

  public get systemType() {
      return this._systemType;
  }
  public get id() {
    return this._id;
  }
  public get type() {
    return this._model.type;
  }
  public get facilityNo() {
    return this._model.facilityNo;
  }
  public get name() {
    return this._model.name;
  }
  public get location() {
    return this._model.location;
  }
  public get isLinked() {
    return this._model.isLinked;
  }
  public get linkedToAmFacilityNo() {
    return this._model.linkedToAmFacilityNo;
  }

  public getModel() {
    return this._model;
  }
}
